import type { FC } from 'react';
import React from 'react';
import { Button } from '../../components';
import type { MaterialIconType } from '../../util/types';

type Props = {
  showLabel: string
  highlight?: boolean
  icon?: MaterialIconType
};

const PdfFilterButton: FC<Props> = ({ showLabel, highlight, icon }: Props) => (
  <Button
    color={'white'}
    highlight={highlight}
    icon={icon}
  >
    {showLabel}
  </Button>
);

export default PdfFilterButton;
